import { Button, ChevronLeftIcon, IconButton, Modal, Typography } from "@povio/ui";
import Image from "next/image";
import { useRouter } from "next/router";

import ToursOverCoverImage from "@/assets/images/ToursOverCover.png";
import { RouteConfig } from "@/config/route.config";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const TourCompletedModal = ({ isOpen, onClose }: Props) => {
  const router = useRouter();

  const handleSeeYourNumber = () => {
    onClose();
    router.push(RouteConfig.Home);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalClassName="p-0!"
      shouldCloseOnInteractOutside={() => false}
    >
      <div className="flex w-full max-w-[480px] flex-col items-center justify-start gap-2">
        <div className="flex w-full flex-row items-center justify-between px-5 py-4">
          <Typography
            size="title-5"
            variant="prominent-1"
            className="text-text-default-1"
          >
            Tour&apos;s Over. Let&apos;s See Your Numbers.
          </Typography>
        </div>
        <div className="px-6">
          <Image
            src={ToursOverCoverImage}
            alt="Tours Over Cover"
            width={432}
            height={240}
            className="h-full w-full rounded-sm object-cover"
          />
        </div>
        <Typography
          size="body-4"
          className="mx-auto max-w-96 self-start px-6 py-2 text-text-default-2"
        >
          You&apos;ve completed the tour, now get your number
        </Typography>
        <div className="flex w-full flex-row items-center justify-center gap-4 p-6">
          <IconButton
            icon={ChevronLeftIcon}
            onPress={() => {
              router.push(RouteConfig.DemoHome);
              onClose();
            }}
            label="Back"
            variant="outlined"
            color="secondary"
            size="s"
          />
          <Button
            variant="contained"
            color="secondary"
            size="s"
            onPress={handleSeeYourNumber}
            width="fill"
          >
            Let&apos;s See Your Number
          </Button>
        </div>
      </div>
    </Modal>
  );
};
